<template>
    <div v-if="!$root.loading">
        <div v-if="error">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    <img class="u-pl2 u-pb2 u-pt2" src="https://shift-manager.mobilerocket.co.uk/storage/business-logos/rocket.png"/>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    <h1 class="t-secondary">401: Unauthorized</h1>
                    <p>We could not log you in to the forms system at this time. Please try again.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'Authenticate',
    data () {
        return {
            error : null
        }
    },
    watch : {
        // '$route.params.id' : {
        //     handler (val) {
        //         this.checkLogin();
        //     },
        //     immediate : true
        // }
    },
    mounted () {
        this.checkLogin();
    },
    methods : {
        checkLogin () {
            let params = {
                    id : this.$route.params.id,
                    token : this.$route.params.token
                };
            this.$root.loading = true;
            this.axios.post(this.$root.env_url + '/api/auth/sso', params)
                .then(response => {
                    // console.log('logged in', response.data);
                    this.$root.login(response.data.access_token);
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not log you in.');
                    this.$root.loading = false;
                    this.error = true;
                    // console.log('error authenticating', error);
                });
        }
    }
}
</script>